export default "__VITE_ASSET__CKQyVm3l__"